import { NavLink } from "react-router-dom";
import { Home, Zap, Sun, Calculator, PhoneCall } from "lucide-react";
import { motion } from "framer-motion";

const tabs = [
  { label: "Home", path: "/", icon: Home, testid: "mobile-bottom-tab-home" },
  { label: "Services", path: "/services", icon: Zap, testid: "mobile-bottom-tab-services" },
  { label: "Offerings", path: "/offerings", icon: Sun, testid: "mobile-bottom-tab-offerings" },
  { label: "Savings", path: "/calculator", icon: Calculator, testid: "mobile-bottom-tab-calculator" },
  { label: "Contact", path: "/contact", icon: PhoneCall, testid: "mobile-bottom-tab-contact" },
];

export default function MobileTabBar() {
  return (
    <nav
      data-testid="mobile-bottom-tab-bar"
      className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-white border-t-2 border-brand/10 shadow-[0_-8px_30px_rgba(3,59,43,0.14)]"
      style={{ paddingBottom: "env(safe-area-inset-bottom, 0px)" }}
    >
      <div className="grid grid-cols-5 h-16">
        {tabs.map((t) => (
          <NavLink
            key={t.path}
            to={t.path}
            data-testid={t.testid}
            className="relative flex flex-col items-center justify-center gap-0.5"
          >
            {({ isActive }) => (
              <>
                {isActive && (
                  <motion.span
                    layoutId="tab-pill"
                    className="absolute top-0 h-1 w-10 rounded-b-full bg-gold"
                    transition={{ type: "spring", stiffness: 500, damping: 35 }}
                  />
                )}
                <t.icon
                  size={21}
                  strokeWidth={isActive ? 2.6 : 2}
                  className={isActive ? "text-brand" : "text-moss"}
                />
                <span
                  className={`text-[10px] font-semibold tracking-wide ${
                    isActive ? "text-brand" : "text-moss"
                  }`}
                >
                  {t.label}
                </span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
